import React from 'react';
import classnames from 'classnames';
import {omit} from 'lodash';

import './input.scss';
import './toggleSwitch.scss';
import FieldDecorator, {FieldDecoratorProps} from '../customDatapoints/FieldDecorator';

type OwnProps = {
	value: boolean;
	onChange: (value: boolean) => void;
	horizontal?: boolean;
	disabled?: boolean;
	toggleColor?: string;
};
type Props = FieldDecoratorProps & OwnProps;

export default React.forwardRef<HTMLInputElement, Props>((props, ref) => {
	const {value, onChange, horizontal, disabled, toggleColor = '#259b23', className, size, ...rest} = props;

	function toggleValue() {
		if (!disabled) {
			onChange(!value);
		}
	}

	const style = {
		backgroundColor: value ? toggleColor : 'gray'
	};
	const fieldDecoratorProps = omit(rest, ['data-testid']);
	return (
		<FieldDecorator
			{...fieldDecoratorProps}
			size={size}
			disabled={disabled}
			onLabelClick={toggleValue}
			className={classnames(
				{
					'checkbox-horizontal': horizontal
				},
				className
			)}>
			<div className="di toggle-field">
				<input ref={ref} type="checkbox" checked={value} onChange={toggleValue} disabled={disabled} {...rest} />
				<span className="checkmark" onClick={toggleValue} style={style} />
			</div>
		</FieldDecorator>
	);
});
